import React from "react";
import { BrowserRouter as Router, Route } from "react-router-dom";
import { Container, Segment } from "semantic-ui-react";

import "semantic-ui-css/semantic.min.css";
import "./App.css";

import { AuthProvider } from "./context/auth";
import AuthRoute from "./util/AuthRoute";

import MenuBar from "./components/MenuBar";
import Home from "./pages/Home";
import Register from "./pages/Register";
import Login from "./pages/Login";
import Board from "./pages/Board";
import Table from "./pages/Table";
import WatchList from "./pages/WatchList";
import MyTeam from "./pages/MyTeam";
import FarmSystem from "./pages/FarmSystem";

function App() {
  return (
    <AuthProvider>
      <Router>
        <Segment inverted>
          <Container>
            <MenuBar />
            <Route exact path="/home" component={Home} />
            <AuthRoute exact path={["", "/login"]} component={Login} />
            <AuthRoute exact path="/register" component={Register} />
            <Route exact path={["/", "/board"]} component={Board} />
            <Route path="/table" component={Table} />
            <Route path="/watchlist" component={WatchList} />
            <Route path="/myTeam" component={MyTeam} />
            <Route path="/farmSystem" component={FarmSystem} />
          </Container>
        </Segment>
      </Router>
    </AuthProvider>
  );
}

export default App;
